/**
 * "base" entrypoint file, handling functionality common to all builds
 */

import defaultConfig from "./config/default.json";
import { init as quantcastInit } from "../../../userConsent/js/quantcast/quantcast.js";
import { initAds } from "./components/ads.js";
import { init as initConfig } from "../../utils/js/configMgr.js";
import { init as emitter } from "./components/emitter.js";

/**
 * Initializer for the entire app
 * @param {object} siteConfig - imported site-specific config json (converted from json to obj at build time)
 */
export function init(siteConfig) {
  // first things first
  infra(siteConfig);

  // next, some synchronous business logic
  quantcastInit();

  // ads module waits for some events before initting himself
  initAds();
}

/**
 * Initializes some infrastructure not directly related to business logic,
 * including assembling the config and setting up custom events.
 * @param {object} siteConfig
 */
function infra(siteConfig) {
  initConfig(defaultConfig, siteConfig);
  emitter();
}
